export enum CerrixRight {
    Default = 0,

    // IM
    ImSupervisorAssignable = 150140,
}
